// extracted by mini-css-extract-plugin
export default {"root":"IAnkvW","brand":"G_NCfg","iconWrapper":"prvC3B","icon":"BRs2sX","iconStateFilled":"OW1YQ2","button":"hBM6fL","tooltipButton":"qxsFC3"};